import { ReactComponent as SuccessIcon } from 'assets/svg/check.svg';
import { ReactComponent as InfoIcon } from 'assets/svg/info-icon.svg';
import { ReactComponent as ErrorIcon } from 'assets/svg/warning.svg';
import classNames from 'classnames/bind';
import { upperFirst } from 'lodash';
import React, { ForwardedRef, ReactNode } from 'react';
import SnackbarSeverity from '../../internal/constants/snackbar';
import styles from './toast.module.scss';

const cx = classNames.bind(styles);

const ICON_WIDTH = 32;

const mapIconBySeverity: Partial<Record<SnackbarSeverity, ReactNode>> = {
  error: <ErrorIcon width={ICON_WIDTH} />,
  success: <SuccessIcon width={ICON_WIDTH} />,
  [SnackbarSeverity.INFO]: <InfoIcon width={ICON_WIDTH} />,
};

type Props = {
  severity?: SnackbarSeverity;
  message: string | ReactNode;
  title: string;
};

function Toast({ severity = SnackbarSeverity.INFO, message, title }: Props, ref: ForwardedRef<HTMLDivElement>) {
  const wrapperClassName = cx('Wrapper', styles[upperFirst(severity)]);

  return (
    <div ref={ref} className={wrapperClassName}>
      {mapIconBySeverity[severity]}
      <div className={styles.Content}>
        <h6 className={styles.Title}>{title}</h6>
        {typeof message === 'string' ? <p>{message}</p> : message}
      </div>
    </div>
  );
}

export default React.forwardRef<HTMLDivElement, Props>(Toast);
